import { useState } from 'react';
import ModalComponent from 'components/Common/Modal';

interface UploadHubPasscodeModalProps {
  openState: {
    isOpen: boolean;
    setIsOpen: (value: boolean) => void;
  };
  onClose?: (hasPasscode: boolean) => void;
}

// ponytail: static UI only — selection isn't persisted or validated, wire up on the passcode ticket
const PASSCODE_ICONS = [
  { key: 'bill', label: 'bill', icon: 'icon-legislation' },
  { key: 'committee', label: 'committee', icon: 'icon-congress' },
  { key: 'minister', label: 'minister', icon: 'icon-person' },
  { key: 'consultation', label: 'consultation', icon: 'icon-consultation' },
  { key: 'briefing', label: 'briefing', icon: 'icon-briefing-material' },
  { key: 'hansard', label: 'hansard', icon: 'icon-parliamentary-record' },
  { key: 'policy-ask', label: 'policy ask', icon: 'icon-policy-ask' },
  { key: 'manifesto', label: 'manifesto', icon: 'icon-manifesto' },
  { key: 'team', label: 'team', icon: 'icon-group' },
];

const iconFor = (key: string) => PASSCODE_ICONS.find((item) => item.key === key)?.icon ?? '';

const UploadHubPasscodeModal = ({ openState, onClose }: UploadHubPasscodeModalProps) => {
  const { isOpen, setIsOpen } = openState;
  const [selected, setSelected] = useState<string[]>([]);

  const addIcon = (key: string) => {
    if (selected.length >= 3) return;
    setSelected([...selected, key]);
  };

  const removeSlot = (index: number) => {
    setSelected(selected.filter((_, i) => i !== index));
  };

  const closeModal = (hasPasscode: boolean) => {
    onClose?.(hasPasscode);
    setIsOpen(false);
  };

  return (
    <ModalComponent
      isOpen={isOpen}
      setIsOpen={(value: boolean) => (value ? setIsOpen(true) : closeModal(selected.length === 3))}
      maxWidth={640}
      onAfterClose={() => setSelected([])}
    >
      <div className='px-4 pb-3 specific-top-padding-20 border-bottom'>
        <h3 className='title-h5-m-bold mb-1 d-flex align-items-center'>
          Passcode
          <span
            className='icon-info main-light-text paragraph-p3 specific-left-margin-8'
            data-tooltip-id='modal-tooltip'
            data-tooltip-content='Anyone with this passcode can open the file. Share it with the people you want to give access.'
          />
        </h3>
        <p className='mb-0 main-light-text paragraph-p2'>
          Pick three icons, in order. The same one more than once is fine.
        </p>
      </div>

      <div className='p-4'>
        <div className='upload-hub-passcode-slots mb-4'>
          {[0, 1, 2].map((slot) => (
            <button
              key={slot}
              type='button'
              className='general-button upload-hub-passcode-slot'
              onClick={() => removeSlot(slot)}
            >
              {selected[slot] && <span className={`${iconFor(selected[slot])} main-light-text`} />}
            </button>
          ))}
        </div>

        <div className='upload-hub-passcode-grid'>
          {PASSCODE_ICONS.map((item) => (
            <button
              key={item.key}
              type='button'
              className='general-button upload-hub-passcode-tile'
              onClick={() => addIcon(item.key)}
            >
              <span className={`${item.icon} title-h3 d-block mb-2 main-light-text`} />
              <span className='paragraph-p3 main-light-text'>{item.label}</span>
            </button>
          ))}
        </div>
      </div>

      <div className='rounded-bottom border-top px-4 d-flex align-items-center justify-content-end py-4'>
        <button className='general-button simple-link-button mr-4' onClick={() => closeModal(false)}>
          Cancel
        </button>
        <button
          className='general-button action-button rounded-pill px-4'
          disabled={selected.length !== 3}
          onClick={() => closeModal(true)}
        >
          Save passcode
        </button>
      </div>
    </ModalComponent>
  );
};

export default UploadHubPasscodeModal;
